import { ReactNode } from 'react';
import { Dialog, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ABOVE_DRAWER_SX } from 'sections/account-settings/subscriptions/checkout-v2/Configure/sharedStyles';
import { RADIUS } from 'components/ui/tokens';

const PAPER_MAX_WIDTH = 520;

/** The frame every cancellation dialog shares: full screen on a phone, above the billing drawer. */
export default function StepDialog({ titleId, onClose, children }: { titleId: string; onClose: () => void; children: ReactNode }) {
  const phone = useMediaQuery(useTheme().breakpoints.down('sm'));
  return (
    <Dialog
      open
      // A stray click outside must never end the visit; Esc and the close button still do.
      onClose={(_event, reason) => reason !== 'backdropClick' && onClose()}
      fullWidth
      fullScreen={phone}
      aria-labelledby={titleId}
      sx={ABOVE_DRAWER_SX}
      PaperProps={{ sx: { position: 'relative', ...(!phone && { maxWidth: PAPER_MAX_WIDTH, borderRadius: RADIUS.panel }) } }}
    >
      {children}
    </Dialog>
  );
}
